import { Logout, Menu, VerifiedUser } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateProfile } from "../../State/Vendor/Action";
import { toast } from "react-toastify";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

const Header = ({ onToggle, onLogout, user, loading }) => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [editData, setEditData] = useState({
    name: user?.name || "",
    email: user?.email || "",
    phone: user?.phone || "",
    password: ""
  });

  useEffect(() => {
    if (user) {
      setEditData({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        password: ""
      });
    }
    setShowPassword(false)
  }, [user, openModal]);

  const handleChange = (e) => {
    // Allow only digits in phone
    if (e.target.name === "phone" && !/^\d*$/.test(e.target.value)) return;
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (!editData.name.trim()) {
      toast.error("Name is required!!");
      return;
    }
    if (!editData.phone.trim()) {
      toast.error("Phone Number is required!!");
      return;
    }
    if (editData.password.trim()) {
      if (editData.password.length < 6 || editData.password.length > 15) {
        toast.error("Password should be between 6 to 15 characters");
        return;
      }
    }
    dispatch(updateProfile(user?.id, editData, setOpenModal))
  };
  return (
    <>
      <header className="flex items-center justify-between p-4 border-b bg-white sticky top-0 z-10">
        <button className=" hover:text-red-500 hover:bg-white" onClick={onToggle}>
          <Menu />
        </button>
        <div className="flex items-center gap-4 ml-auto">
          <div className="relative group">
            {/* Avatar */}
            <div
              className="h-8 w-8 rounded-full bg-red-500 text-white flex items-center justify-center text-md font-bold uppercase cursor-pointer"
            >
              {user?.name?.charAt(0) || "S"}
            </div>

            {/* Dropdown */}
            <div className="absolute right-0 mt-1 w-56 bg-white border border-gray-200 rounded-xl shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
              <div className="px-4 py-3 text-sm">
                <div className="font-semibold">{user?.name || "Seller"}</div>
                <div className="text-gray-500 text-xs">{user?.email || "Seller@gmail.com"}</div>
              </div>
              <hr />
              <button
                onClick={() => setOpenModal(true)}
                className="w-full text-left px-4 py-2 text-sm flex items-center gap-2 hover:bg-gray-100 transition">
                <VerifiedUser className="h-4 w-4" /> Profile
              </button>
              <button
                onClick={onLogout}
                className="w-full text-left px-4 py-2 text-sm flex items-center gap-2 hover:bg-gray-100 transition text-red-500"
              >
                <Logout className="h-4 w-4" /> Logout
              </button>
            </div>
          </div>
        </div>
      </header>
      {/* Profile Modal */}
      {openModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50 px-4">
          <div className="relative bg-white rounded-xl shadow-lg w-full max-w-md p-6 max-h-[90vh] overflow-y-auto">
            {/* Close Icon */}
            <button
              onClick={() => setOpenModal(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 hover:bg-white text-xl font-bold"
            >
              ✕
            </button>

            <h2 className="text-xl font-bold mb-4 text-center">Profile Details</h2>

            {/* Name */}
            <label className="block text-sm font-medium mb-1">Name</label>
            <input
              type="text"
              name="name"
              value={editData.name}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2 mb-3 focus:ring focus:ring-red-200 outline-none"
            />

            {/* Email (read-only) */}
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              value={editData.email}
              readOnly
              className="w-full border rounded-md px-3 py-2 mb-3 bg-gray-100 cursor-not-allowed"
            />

            {/* Phone */}
            <label className="block text-sm font-medium mb-1">Phone</label>
            <input
              type="text"
              name="phone"
              value={editData.phone}
              onChange={handleChange}
              maxLength={10}
              className="w-full border rounded-md px-3 py-2 mb-3 focus:ring focus:ring-red-200 outline-none"
            />

            {/* Password */}
            <div className="relative w-full">
              <label className="block text-sm font-medium mb-1">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={editData.password}
                onChange={handleChange}
                placeholder="Enter new password"
                className="w-full border rounded-md px-3 py-2 pr-10 mb-6 focus:ring focus:ring-red-200 outline-none"
              />
              <button
                type="button"
                className="absolute right-3 top-[38px] text-gray-500 hover:text-gray-700"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <EyeSlashIcon className="h-5 w-5" />
                ) : (
                  <EyeIcon className="h-5 w-5" />
                )}
              </button>
            </div>

            {/* Centered Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={handleSave}
                className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg w-full sm:w-auto"
              >
                {loading ? "Updating...." : "Save Changes"}
              </button>
              <button
                onClick={onLogout}
                className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2 rounded-lg w-full sm:w-auto"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
};

export default Header;
